import React from 'react';
import RemoveEntryModal from './RemoveEntryLabel';

const RemovePassengerLabel = ({handleRemovePassenger, passenger}) => (
  <RemoveEntryModal
    handleRemove = {handleRemovePassenger}
    id={passenger.id}
    question={`Remove Passenger ${passenger.passengerFirstName} ${passenger.passengerLastName} ?`}
  />
)

export default RemovePassengerLabel;


// WEBPACK FOOTER //
// ./src/component/RemovePassengerLabel.js